// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  padding: 24px;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  font-size: 28px;
  color: #333;
  margin: 0 0 8px 0;
}

.page-header p {
  color: #666;
  margin: 0;
}

.error-message {
  background: #fee;
  color: #c00;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.error-message button {
  background: none;
  border: none;
  color: #c00;
  cursor: pointer;
  font-size: 16px;
}

.loading-spinner {
  text-align: center;
  padding: 40px;
  color: #666;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  color: #333;
}

.empty-state p {
  color: #666;
  margin: 0;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.meetings-table {
  width: 100%;
  min-width: 1200px;
  border-collapse: collapse;
  font-size: 13px;
}

.meetings-table th,
.meetings-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.meetings-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}

.col-expand { width: 40px; }
.col-id { width: 50px; }
.col-date { width: 140px; }
.col-name { width: 100px; }
.col-phone { width: 120px; }
.col-email { width: 180px; }
.col-town { width: 100px; }
.col-subject { width: 120px; }
.col-message { width: 150px; }
.col-status { width: 100px; }
.col-assign { width: 160px; }

.email-source-badge {
  margin-left: 6px;
  cursor: help;
  font-size: 14px;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.email-source-badge:hover {
  opacity: 1;
}

.meetings-table tbody tr:hover {
  background: #f8f9fa;
}

.meetings-table tbody tr.expanded {
  background: #e8f4fd;
}

.expand-cell {
  text-align: center;
}

.expand-indicator {
  display: inline-block;
  color: #0066cc;
  font-size: 12px;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

.id-cell {
  font-weight: 600;
  color: #0066cc;
}

.date-cell {
  white-space: nowrap;
  color: #666;
  font-size: 12px;
}

.phone-link,
.email-link {
  color: #0066cc;
  text-decoration: none;
}

.phone-link:hover,
.email-link:hover {
  text-decoration: underline;
}

.message-cell {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-message {
  color: #aaa;
}

.status-cell {
  text-align: center;
}

.status-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
}

.status-btn {
  padding: 4px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: #f8f9fa;
  color: #666;
}

.status-btn.yes.active {
  background: #28a745;
  border-color: #28a745;
  color: white;
}

.status-btn.no.active {
  background: #dc3545;
  border-color: #dc3545;
  color: white;
}

.status-btn:hover:not(:disabled) {
  opacity: 0.8;
}

.status-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.expanded-row td {
  background: #f8f9fa;
  padding: 0 !important;
}

.expanded-content {
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.expanded-section h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 14px;
}

.message-full {
  background: white;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #ddd;
  min-height: 100px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.5;
}

.message-full table {
  border-collapse: collapse;
  margin: 10px 0;
  width: auto;
  background: white;
}

.message-full table th,
.message-full table td {
  border: 1px solid #ddd;
  padding: 8px 12px;
  text-align: left;
}

.message-full table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}

.message-full table tr:nth-child(even) {
  background-color: #fafafa;
}

.notes-textarea {
  width: 100%;
  min-height: 100px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.notes-textarea:focus {
  outline: none;
  border-color: #0066cc;
}

.notes-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.approve-btn {
  padding: 8px 16px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.approve-btn:hover:not(:disabled) {
  background: #218838;
}

.approve-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.saving-indicator {
  display: inline-block;
  font-size: 12px;
  color: #666;
  font-style: italic;
}

.tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

.tab-btn {
  padding: 10px 20px;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  color: #666;
}

.tab-btn:hover {
  background: #e9ecef;
}

.tab-btn.active {
  background: #0066cc;
  border-color: #0066cc;
  color: white;
}

.col-rejected { width: 100px; }

.rejected-cell {
  text-align: center;
}

.assign-cell {
  position: relative;
}

.assigned-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.assigned-name {
  font-size: 12px;
  font-weight: 500;
  color: #333;
}

.reassign-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 4px;
}

.reassign-btn:hover {
  background: #e0e0e0;
}

.assign-trigger-btn {
  padding: 6px 14px;
  border: 1px solid #0066cc;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background: linear-gradient(135deg, #f0f6ff 0%, #e3f0ff 100%);
  color: #0066cc;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 4px rgba(0, 102, 204, 0.1);
}

.assign-trigger-btn:hover {
  background: linear-gradient(135deg, #0066cc 0%, #0052a3 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 102, 204, 0.2);
}

.assign-icon {
  font-size: 14px;
}

.assign-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 9998;
}

.assign-dropdown-fixed {
  position: fixed;
  z-index: 10000;
  animation: slideDownFixed 0.25s ease-out;
  pointer-events: auto;
  min-width: 300px;
  width: max-content;
  max-width: 90vw;
}

@keyframes slideDownFixed {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.assign-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  margin-top: 0;
  z-index: 9999;
  animation: slideDown 0.25s ease-out;
  pointer-events: auto;
  min-width: 300px;
  width: max-content;
  max-width: 90vw;
  will-change: transform, opacity;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.assign-dropdown-content {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
  min-width: 280px;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.assign-dropdown-content::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #0066cc;
}

.assign-dropdown-header {
  background: linear-gradient(135deg, #0066cc 0%, #0052a3 100%);
  color: white;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 13px;
}

.assign-dropdown-icon {
  font-size: 18px;
}

.assign-dropdown-title {
  flex: 1 1;
}

.assign-dropdown-body {
  padding: 16px;
}

.assign-search {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  margin-bottom: 10px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
  transition: all 0.2s;
}

.assign-search:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);
}

.assign-no-results {
  margin-top: 8px;
  color: #777;
  font-size: 12px;
  text-align: center;
}

.assign-employee-list {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.assign-employee-option {
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-bottom: 1px solid #eee;
  font-size: 13px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  text-align: left;
}

.assign-employee-option:last-child {
  border-bottom: none;
}

.assign-employee-option:hover {
  background: #f0f7ff;
}

.assign-employee-option:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px #0066cc;
}

.assign-employee-option.selected {
  background: #e6f2ff;
  color: #0052a3;
  font-weight: 600;
}

.assign-leads-count {
  flex-shrink: 0;
  min-width: 26px;
  padding: 2px 7px;
  border-radius: 10px;
  background: #e9ecef;
  color: #555;
  text-align: center;
  font-size: 11px;
}

.assign-employee-option.selected .assign-leads-count {
  background: #0066cc;
  color: white;
}

.assign-dropdown-footer {
  padding: 12px 16px;
  background: #f8f9fa;
  display: flex;
  gap: 8px;
  border-top: 1px solid #e0e0e0;
}

.assign-confirm-btn {
  flex: 1 1;
  padding: 10px 16px;
  background: linear-gradient(135deg, #28a745 0%, #218838 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(40, 167, 69, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.assign-confirm-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(40, 167, 69, 0.4);
}

.assign-confirm-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.check-icon {
  font-size: 16px;
  font-weight: bold;
}

.spinner {
  display: inline-block;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.assign-cancel-btn {
  padding: 10px 16px;
  background: white;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
}

.assign-cancel-btn:hover {
  background: #f8f9fa;
  border-color: #999;
  color: #333;
}

.reject-btn {
  padding: 6px 12px;
  border: 1px solid #dc3545;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: #fff;
  color: #dc3545;
}

.reject-btn:hover:not(:disabled) {
  background: #dc3545;
  color: white;
}

.reject-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.restore-btn {
  padding: 6px 12px;
  border: 1px solid #28a745;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: #fff;
  color: #28a745;
}

.restore-btn:hover:not(:disabled) {
  background: #28a745;
  color: white;
}

.restore-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.action-buttons {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
}

.delete-btn {
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  background: #fff;
  line-height: 1;
}

.delete-btn:hover:not(:disabled) {
  background: #dc3545;
  border-color: #dc3545;
}

.delete-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-btn.confirm-delete {
  background: #dc3545;
  color: #fff;
  border-color: #dc3545;
}

.modal-btn.confirm-delete:hover {
  background: #c82333;
  border-color: #bd2130;
}

/* Rejected row styling in Rejected Reports tab */
.rejected-row {
  background: #fff5f5 !important;
}

.rejected-row td {
  color: #666;
}

.rejected-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #f8d7da;
  color: #721c24;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-content {
  background: white;
  padding: 32px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.modal-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.modal-content h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 20px;
}

.modal-content p {
  margin: 0 0 24px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.modal-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.modal-btn.cancel {
  background: #f8f9fa;
  color: #666;
  border: 1px solid #ddd;
}

.modal-btn.cancel:hover {
  background: #e9ecef;
}

.modal-btn.confirm {
  background: #dc3545;
  color: white;
}

.modal-btn.confirm:hover {
  background: #c82333;
}

.modal-btn.confirm-restore {
  background: #28a745;
  color: white;
}

.modal-btn.confirm-restore:hover {
  background: #218838;
}

@media (max-width: 1400px) {
  .expanded-content {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .meeting-manager-page {
    padding: 16px;
  }

  .meetings-table {
    font-size: 12px;
  }

  .meetings-table th,
  .meetings-table td {
    padding: 8px;
  }

  .tabs {
    flex-direction: column;
  }
}

/* Inline editing styles */
.editable-cell {
  position: relative;
}

.editable-value {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.editable-value:hover {
  background: #f0f7ff;
}

.editable-value .edit-icon {
  opacity: 0;
  font-size: 12px;
  color: #4a90e2;
  transition: opacity 0.2s;
}

.editable-value:hover .edit-icon {
  opacity: 1;
}

.empty-value {
  color: #999;
  font-style: italic;
  font-size: 13px;
}

.inline-edit {
  display: flex;
  align-items: center;
  gap: 4px;
}

.inline-input {
  padding: 4px 8px;
  border: 2px solid #4a90e2;
  border-radius: 4px;
  font-size: 14px;
  min-width: 100px;
  outline: none;
}

.inline-actions {
  display: flex;
  gap: 2px;
}

.inline-save,
.inline-cancel {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background 0.2s;
}

.inline-save {
  background: #28a745;
  color: white;
}

.inline-save:hover {
  background: #218838;
}

.inline-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.inline-cancel {
  background: #6c757d;
  color: white;
}

.inline-cancel:hover {
  background: #5a6268;
}

.inline-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== Attachments Styles ===== */
.attachments-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.attachment-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  transition: all 0.2s;
}

.attachment-item:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.attachment-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.attachment-info {
  flex: 1 1;
  min-width: 0;
}

.attachment-name {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
  word-break: break-word;
}

.attachment-size {
  font-size: 12px;
  color: #6c757d;
}

.attachment-download-btn,
.attachment-preview-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.attachment-download-btn {
  background: #28a745;
  color: white;
}

.attachment-download-btn:hover {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.attachment-preview-btn {
  background: #007bff;
  color: white;
}

.attachment-preview-btn:hover {
  background: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.expanded-section h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #2c3e50;
  font-size: 16px;
}

/* Attachments Dropdown Header */
.attachments-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
  padding: 8px;
  margin: -8px;
  border-radius: 4px;
}

.attachments-header:hover {
  background: #f0f0f0;
}

.attachments-header h4 {
  display: flex;
  align-items: center;
  margin: 0;
}

.dropdown-arrow {
  display: inline-block;
  margin-right: 8px;
  font-size: 12px;
  transition: transform 0.2s ease;
  color: #666;
}

.dropdown-arrow.expanded {
  transform: rotate(90deg);
}

.attachments-header h4:hover .dropdown-arrow {
  color: #007bff;
}

/* ===== Compact Attachments Styles ===== */
.attachments-section {
  margin-top: 15px;
}

.attachments-compact-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
}

.attachment-compact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  transition: all 0.2s;
  min-height: 40px;
  max-height: 50px;
}

.attachment-compact-item:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.attachment-compact-icon {
  font-size: 18px;
  flex-shrink: 0;
  width: 24px;
  text-align: center;
}

.attachment-compact-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.attachment-compact-name {
  font-weight: 500;
  color: #2c3e50;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}

.attachment-compact-size {
  font-size: 11px;
  color: #6c757d;
  flex-shrink: 0;
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 500;
}

.attachment-compact-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.attachment-compact-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.attachment-compact-btn.download {
  background: #28a745;
  color: white;
}

.attachment-compact-btn.download:hover {
  background: #218838;
  transform: scale(1.1);
}

.attachment-compact-btn.preview {
  background: #007bff;
  color: white;
}

.attachment-compact-btn.preview:hover {
  background: #0056b3;
  transform: scale(1.1);
}

.attachment-compact-btn:active {
  transform: scale(0.95);
}

/* Editable email field styles */
.editable-value-container {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: relative;
}

.editable-email {
  color: #007bff;
  text-decoration: none;
}

.editable-email:hover {
  text-decoration: underline;
}

.edit-icon-overlay {
  cursor: pointer;
  color: #6c757d;
  font-size: 14px;
  opacity: 0.6;
  transition: all 0.2s;
  padding: 2px 4px;
  border-radius: 3px;
}

.edit-icon-overlay:hover {
  opacity: 1;
  color: #007bff;
  background: #f0f0f0;
}

.editable-cell .inline-input[type="email"] {
  min-width: 200px;
}

/* Editable email field border highlight */
.editable-value-container {
  border: 1px dashed #007bff;
  padding: 4px 8px;
  border-radius: 4px;
  background: #f8f9fa;
}

.editable-value-container:hover {
  background: #e7f3ff;
  border-color: #0056b3;
}

.recent-assignments-table .recent-message {
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-assignments-table td {
  vertical-align: middle;
}

.recent-assignments-table > tbody > tr:not(.expanded-row) {
  cursor: pointer;
}

.recent-assignments-table > tbody > tr.overdue-uncontacted > td {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}

.recent-assignments-table > tbody > tr.overdue-uncontacted:hover > td,
.recent-assignments-table > tbody > tr.overdue-uncontacted.expanded > td {
  background: #fecaca;
}

.recent-message-full {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.recent-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 20px 0 4px;
}

.recent-pagination button {
  min-width: 38px;
  height: 38px;
  border: 1px solid #d6dce4;
  border-radius: 6px;
  background: #fff;
  color: #334155;
  cursor: pointer;
}

.recent-pagination button:hover,
.recent-pagination button.active {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
}
.meeting-manager-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.meeting-manager-title svg {
  flex-shrink: 0;
  color: #2563eb;
}
.assignment-author {
  display: block;
  margin-top: 0.2rem;
  color: #64748b;
  font-size: 0.75rem;
}

.original-assignment-date {
  display: block;
  margin-top: 0.25rem;
  color: #64748b;
  font-size: 0.75rem;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/MeetingManager.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,cAAc,WAAW,EAAE;AAC3B,UAAU,WAAW,EAAE;AACvB,YAAY,YAAY,EAAE;AAC1B,YAAY,YAAY,EAAE;AAC1B,aAAa,YAAY,EAAE;AAC3B,aAAa,YAAY,EAAE;AAC3B,YAAY,YAAY,EAAE;AAC1B,eAAe,YAAY,EAAE;AAC7B,eAAe,YAAY,EAAE;AAC7B,cAAc,YAAY,EAAE;AAC5B,cAAc,YAAY,EAAE;;AAE5B;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA,gBAAgB,YAAY,EAAE;;AAE9B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".page-container {\n  padding: 24px;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-header h2 {\n  font-size: 28px;\n  color: #333;\n  margin: 0 0 8px 0;\n}\n\n.page-header p {\n  color: #666;\n  margin: 0;\n}\n\n.error-message {\n  background: #fee;\n  color: #c00;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.error-message button {\n  background: none;\n  border: none;\n  color: #c00;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.loading-spinner {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: #f8f9fa;\n  border-radius: 12px;\n}\n\n.empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.empty-state h3 {\n  margin: 0 0 8px 0;\n  color: #333;\n}\n\n.empty-state p {\n  color: #666;\n  margin: 0;\n}\n\n.table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.meetings-table {\n  width: 100%;\n  min-width: 1200px;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.meetings-table th,\n.meetings-table td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.meetings-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  color: #333;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.col-expand { width: 40px; }\n.col-id { width: 50px; }\n.col-date { width: 140px; }\n.col-name { width: 100px; }\n.col-phone { width: 120px; }\n.col-email { width: 180px; }\n.col-town { width: 100px; }\n.col-subject { width: 120px; }\n.col-message { width: 150px; }\n.col-status { width: 100px; }\n.col-assign { width: 160px; }\n\n.email-source-badge {\n  margin-left: 6px;\n  cursor: help;\n  font-size: 14px;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n}\n\n.email-source-badge:hover {\n  opacity: 1;\n}\n\n.meetings-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.meetings-table tbody tr.expanded {\n  background: #e8f4fd;\n}\n\n.expand-cell {\n  text-align: center;\n}\n\n.expand-indicator {\n  display: inline-block;\n  color: #0066cc;\n  font-size: 12px;\n  user-select: none;\n  pointer-events: none;\n}\n\n.id-cell {\n  font-weight: 600;\n  color: #0066cc;\n}\n\n.date-cell {\n  white-space: nowrap;\n  color: #666;\n  font-size: 12px;\n}\n\n.phone-link,\n.email-link {\n  color: #0066cc;\n  text-decoration: none;\n}\n\n.phone-link:hover,\n.email-link:hover {\n  text-decoration: underline;\n}\n\n.message-cell {\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.no-message {\n  color: #aaa;\n}\n\n.status-cell {\n  text-align: center;\n}\n\n.status-buttons {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n}\n\n.status-btn {\n  padding: 4px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #f8f9fa;\n  color: #666;\n}\n\n.status-btn.yes.active {\n  background: #28a745;\n  border-color: #28a745;\n  color: white;\n}\n\n.status-btn.no.active {\n  background: #dc3545;\n  border-color: #dc3545;\n  color: white;\n}\n\n.status-btn:hover:not(:disabled) {\n  opacity: 0.8;\n}\n\n.status-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.expanded-row td {\n  background: #f8f9fa;\n  padding: 0 !important;\n}\n\n.expanded-content {\n  padding: 20px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.expanded-section h4 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 14px;\n}\n\n.message-full {\n  background: white;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  min-height: 100px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.message-full table {\n  border-collapse: collapse;\n  margin: 10px 0;\n  width: auto;\n  background: white;\n}\n\n.message-full table th,\n.message-full table td {\n  border: 1px solid #ddd;\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.message-full table th {\n  background-color: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n}\n\n.message-full table tr:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.notes-textarea {\n  width: 100%;\n  min-height: 100px;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.notes-textarea:focus {\n  outline: none;\n  border-color: #0066cc;\n}\n\n.notes-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.approve-btn {\n  padding: 8px 16px;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.approve-btn:hover:not(:disabled) {\n  background: #218838;\n}\n\n.approve-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.saving-indicator {\n  display: inline-block;\n  font-size: 12px;\n  color: #666;\n  font-style: italic;\n}\n\n.tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.tab-btn {\n  padding: 10px 20px;\n  background: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: #666;\n}\n\n.tab-btn:hover {\n  background: #e9ecef;\n}\n\n.tab-btn.active {\n  background: #0066cc;\n  border-color: #0066cc;\n  color: white;\n}\n\n.col-rejected { width: 100px; }\n\n.rejected-cell {\n  text-align: center;\n}\n\n.assign-cell {\n  position: relative;\n}\n\n.assigned-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.assigned-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: #333;\n}\n\n.reassign-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 2px 4px;\n  border-radius: 4px;\n}\n\n.reassign-btn:hover {\n  background: #e0e0e0;\n}\n\n.assign-trigger-btn {\n  padding: 6px 14px;\n  border: 1px solid #0066cc;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  background: linear-gradient(135deg, #f0f6ff 0%, #e3f0ff 100%);\n  color: #0066cc;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  box-shadow: 0 2px 4px rgba(0, 102, 204, 0.1);\n}\n\n.assign-trigger-btn:hover {\n  background: linear-gradient(135deg, #0066cc 0%, #0052a3 100%);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 102, 204, 0.2);\n}\n\n.assign-icon {\n  font-size: 14px;\n}\n\n.assign-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n  z-index: 9998;\n}\n\n.assign-dropdown-fixed {\n  position: fixed;\n  z-index: 10000;\n  animation: slideDownFixed 0.25s ease-out;\n  pointer-events: auto;\n  min-width: 300px;\n  width: max-content;\n  max-width: 90vw;\n}\n\n@keyframes slideDownFixed {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.assign-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: 0;\n  z-index: 9999;\n  animation: slideDown 0.25s ease-out;\n  pointer-events: auto;\n  min-width: 300px;\n  width: max-content;\n  max-width: 90vw;\n  will-change: transform, opacity;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.assign-dropdown-content {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);\n  min-width: 280px;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n}\n\n.assign-dropdown-content::before {\n  content: '';\n  position: absolute;\n  top: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid #0066cc;\n}\n\n.assign-dropdown-header {\n  background: linear-gradient(135deg, #0066cc 0%, #0052a3 100%);\n  color: white;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.assign-dropdown-icon {\n  font-size: 18px;\n}\n\n.assign-dropdown-title {\n  flex: 1;\n}\n\n.assign-dropdown-body {\n  padding: 16px;\n}\n\n.assign-search {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  margin-bottom: 10px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 13px;\n  font-family: inherit;\n  transition: all 0.2s;\n}\n\n.assign-search:focus {\n  outline: none;\n  border-color: #0066cc;\n  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);\n}\n\n.assign-no-results {\n  margin-top: 8px;\n  color: #777;\n  font-size: 12px;\n  text-align: center;\n}\n\n.assign-employee-list {\n  max-height: 240px;\n  overflow-y: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n}\n\n.assign-employee-option {\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-bottom: 1px solid #eee;\n  font-size: 13px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  text-align: left;\n}\n\n.assign-employee-option:last-child {\n  border-bottom: none;\n}\n\n.assign-employee-option:hover {\n  background: #f0f7ff;\n}\n\n.assign-employee-option:focus {\n  outline: none;\n  box-shadow: inset 0 0 0 2px #0066cc;\n}\n\n.assign-employee-option.selected {\n  background: #e6f2ff;\n  color: #0052a3;\n  font-weight: 600;\n}\n\n.assign-leads-count {\n  flex-shrink: 0;\n  min-width: 26px;\n  padding: 2px 7px;\n  border-radius: 10px;\n  background: #e9ecef;\n  color: #555;\n  text-align: center;\n  font-size: 11px;\n}\n\n.assign-employee-option.selected .assign-leads-count {\n  background: #0066cc;\n  color: white;\n}\n\n.assign-dropdown-footer {\n  padding: 12px 16px;\n  background: #f8f9fa;\n  display: flex;\n  gap: 8px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.assign-confirm-btn {\n  flex: 1;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #28a745 0%, #218838 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s;\n  box-shadow: 0 2px 6px rgba(40, 167, 69, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.assign-confirm-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(40, 167, 69, 0.4);\n}\n\n.assign-confirm-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n.check-icon {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.spinner {\n  display: inline-block;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.assign-cancel-btn {\n  padding: 10px 16px;\n  background: white;\n  color: #666;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.assign-cancel-btn:hover {\n  background: #f8f9fa;\n  border-color: #999;\n  color: #333;\n}\n\n.reject-btn {\n  padding: 6px 12px;\n  border: 1px solid #dc3545;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #fff;\n  color: #dc3545;\n}\n\n.reject-btn:hover:not(:disabled) {\n  background: #dc3545;\n  color: white;\n}\n\n.reject-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #f8d7da;\n  border-color: #f5c6cb;\n  color: #721c24;\n}\n\n.restore-btn {\n  padding: 6px 12px;\n  border: 1px solid #28a745;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #fff;\n  color: #28a745;\n}\n\n.restore-btn:hover:not(:disabled) {\n  background: #28a745;\n  color: white;\n}\n\n.restore-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-btn {\n  padding: 4px 8px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #fff;\n  line-height: 1;\n}\n\n.delete-btn:hover:not(:disabled) {\n  background: #dc3545;\n  border-color: #dc3545;\n}\n\n.delete-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.modal-btn.confirm-delete {\n  background: #dc3545;\n  color: #fff;\n  border-color: #dc3545;\n}\n\n.modal-btn.confirm-delete:hover {\n  background: #c82333;\n  border-color: #bd2130;\n}\n\n/* Rejected row styling in Rejected Reports tab */\n.rejected-row {\n  background: #fff5f5 !important;\n}\n\n.rejected-row td {\n  color: #666;\n}\n\n.rejected-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: #f8d7da;\n  color: #721c24;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.modal-content {\n  background: white;\n  padding: 32px;\n  border-radius: 12px;\n  max-width: 400px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.modal-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.modal-content h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.modal-content p {\n  margin: 0 0 24px 0;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.modal-btn {\n  padding: 10px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.modal-btn.cancel {\n  background: #f8f9fa;\n  color: #666;\n  border: 1px solid #ddd;\n}\n\n.modal-btn.cancel:hover {\n  background: #e9ecef;\n}\n\n.modal-btn.confirm {\n  background: #dc3545;\n  color: white;\n}\n\n.modal-btn.confirm:hover {\n  background: #c82333;\n}\n\n.modal-btn.confirm-restore {\n  background: #28a745;\n  color: white;\n}\n\n.modal-btn.confirm-restore:hover {\n  background: #218838;\n}\n\n@media (max-width: 1400px) {\n  .expanded-content {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .meeting-manager-page {\n    padding: 16px;\n  }\n\n  .meetings-table {\n    font-size: 12px;\n  }\n\n  .meetings-table th,\n  .meetings-table td {\n    padding: 8px;\n  }\n\n  .tabs {\n    flex-direction: column;\n  }\n}\n\n/* Inline editing styles */\n.editable-cell {\n  position: relative;\n}\n\n.editable-value {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.editable-value:hover {\n  background: #f0f7ff;\n}\n\n.editable-value .edit-icon {\n  opacity: 0;\n  font-size: 12px;\n  color: #4a90e2;\n  transition: opacity 0.2s;\n}\n\n.editable-value:hover .edit-icon {\n  opacity: 1;\n}\n\n.empty-value {\n  color: #999;\n  font-style: italic;\n  font-size: 13px;\n}\n\n.inline-edit {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.inline-input {\n  padding: 4px 8px;\n  border: 2px solid #4a90e2;\n  border-radius: 4px;\n  font-size: 14px;\n  min-width: 100px;\n  outline: none;\n}\n\n.inline-actions {\n  display: flex;\n  gap: 2px;\n}\n\n.inline-save,\n.inline-cancel {\n  padding: 4px 8px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: bold;\n  transition: background 0.2s;\n}\n\n.inline-save {\n  background: #28a745;\n  color: white;\n}\n\n.inline-save:hover {\n  background: #218838;\n}\n\n.inline-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.inline-cancel {\n  background: #6c757d;\n  color: white;\n}\n\n.inline-cancel:hover {\n  background: #5a6268;\n}\n\n.inline-cancel:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ===== Attachments Styles ===== */\n.attachments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.attachment-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.attachment-item:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.attachment-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.attachment-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.attachment-name {\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 4px;\n  word-break: break-word;\n}\n\n.attachment-size {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.attachment-download-btn,\n.attachment-preview-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.attachment-download-btn {\n  background: #28a745;\n  color: white;\n}\n\n.attachment-download-btn:hover {\n  background: #218838;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.attachment-preview-btn {\n  background: #007bff;\n  color: white;\n}\n\n.attachment-preview-btn:hover {\n  background: #0056b3;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.expanded-section h4 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  color: #2c3e50;\n  font-size: 16px;\n}\n\n/* Attachments Dropdown Header */\n.attachments-header {\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.2s;\n  padding: 8px;\n  margin: -8px;\n  border-radius: 4px;\n}\n\n.attachments-header:hover {\n  background: #f0f0f0;\n}\n\n.attachments-header h4 {\n  display: flex;\n  align-items: center;\n  margin: 0;\n}\n\n.dropdown-arrow {\n  display: inline-block;\n  margin-right: 8px;\n  font-size: 12px;\n  transition: transform 0.2s ease;\n  color: #666;\n}\n\n.dropdown-arrow.expanded {\n  transform: rotate(90deg);\n}\n\n.attachments-header h4:hover .dropdown-arrow {\n  color: #007bff;\n}\n\n/* ===== Compact Attachments Styles ===== */\n.attachments-section {\n  margin-top: 15px;\n}\n\n.attachments-compact-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.attachment-compact-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  transition: all 0.2s;\n  min-height: 40px;\n  max-height: 50px;\n}\n\n.attachment-compact-item:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.attachment-compact-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n  width: 24px;\n  text-align: center;\n}\n\n.attachment-compact-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.attachment-compact-name {\n  font-weight: 500;\n  color: #2c3e50;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n\n.attachment-compact-size {\n  font-size: 11px;\n  color: #6c757d;\n  flex-shrink: 0;\n  background: #e9ecef;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-weight: 500;\n}\n\n.attachment-compact-actions {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.attachment-compact-btn {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.attachment-compact-btn.download {\n  background: #28a745;\n  color: white;\n}\n\n.attachment-compact-btn.download:hover {\n  background: #218838;\n  transform: scale(1.1);\n}\n\n.attachment-compact-btn.preview {\n  background: #007bff;\n  color: white;\n}\n\n.attachment-compact-btn.preview:hover {\n  background: #0056b3;\n  transform: scale(1.1);\n}\n\n.attachment-compact-btn:active {\n  transform: scale(0.95);\n}\n\n/* Editable email field styles */\n.editable-value-container {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  position: relative;\n}\n\n.editable-email {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.editable-email:hover {\n  text-decoration: underline;\n}\n\n.edit-icon-overlay {\n  cursor: pointer;\n  color: #6c757d;\n  font-size: 14px;\n  opacity: 0.6;\n  transition: all 0.2s;\n  padding: 2px 4px;\n  border-radius: 3px;\n}\n\n.edit-icon-overlay:hover {\n  opacity: 1;\n  color: #007bff;\n  background: #f0f0f0;\n}\n\n.editable-cell .inline-input[type=\"email\"] {\n  min-width: 200px;\n}\n\n/* Editable email field border highlight */\n.editable-value-container {\n  border: 1px dashed #007bff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  background: #f8f9fa;\n}\n\n.editable-value-container:hover {\n  background: #e7f3ff;\n  border-color: #0056b3;\n}\n\n.recent-assignments-table .recent-message {\n  max-width: 420px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.recent-assignments-table td {\n  vertical-align: middle;\n}\n\n.recent-assignments-table > tbody > tr:not(.expanded-row) {\n  cursor: pointer;\n}\n\n.recent-assignments-table > tbody > tr.overdue-uncontacted > td {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.recent-assignments-table > tbody > tr.overdue-uncontacted:hover > td,\n.recent-assignments-table > tbody > tr.overdue-uncontacted.expanded > td {\n  background: #fecaca;\n}\n\n.recent-message-full {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.recent-pagination {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 20px 0 4px;\n}\n\n.recent-pagination button {\n  min-width: 38px;\n  height: 38px;\n  border: 1px solid #d6dce4;\n  border-radius: 6px;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n}\n\n.recent-pagination button:hover,\n.recent-pagination button.active {\n  border-color: #007bff;\n  background: #007bff;\n  color: #fff;\n}\n.meeting-manager-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.meeting-manager-title svg {\n  flex-shrink: 0;\n  color: #2563eb;\n}\n.assignment-author {\n  display: block;\n  margin-top: 0.2rem;\n  color: #64748b;\n  font-size: 0.75rem;\n}\n\n.original-assignment-date {\n  display: block;\n  margin-top: 0.25rem;\n  color: #64748b;\n  font-size: 0.75rem;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
